import { render, staticRenderFns } from "./DevApiWiringHint.vue?vue&type=template&id=42aa5428&scoped=true"
import script from "./DevApiWiringHint.vue?vue&type=script&lang=js"
export * from "./DevApiWiringHint.vue?vue&type=script&lang=js"
import style0 from "./DevApiWiringHint.vue?vue&type=style&index=0&id=42aa5428&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa5428",
  null
  
)

export default component.exports